
import { State } from 'vuex-class';
import * as moment from 'moment';
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

@Component
export default class DateFilter extends Vue {
    @Prop({ default: '' })
    value: moment.Moment;
    @Prop({ default: '' })
    placeholder: string;
    @Prop({ default: '' })
    label: string;
    @Prop()
    minDate: moment.Moment;
    @Prop()
    maxDate: moment.Moment;

    private date: string = '';

    private dateOptions = {
        allowInputToggle: true,
        useCurrent: false,
        format: 'DD/MM/YYYY',
        icons: {
            previous: 'fa fa-arrow-left',
            next: 'fa fa-arrow-right'
        },
        viewMode: 'years',
        widgetPositioning: {
            horizontal: 'left',
            vertical: 'auto'
        }
    };

    created() {
        if (this.value) {
            this.onValueUpdate(this.value);
        }
    }

    @Watch('value')
    private onValueUpdate(newValue: moment.Moment) {
        if (!newValue || !newValue.isValid()) {
            this.date = null;
        } else {
            this.date = newValue.format(this.dateOptions.format);
        }
    }

    @Watch('minDate')
    private onMinDateUpdate(newValue: moment.Moment) {
        this.updateDateOptions('minDate', newValue);
    }

    @Watch('maxDate')
    private onMaxDateUpdate(newValue: moment.Moment) {
        this.updateDateOptions('maxDate', newValue);
    }

    @Watch('date')
    private handleInputChange(newValue: string) {
        this.$emit('update', newValue && moment(this.date, this.dateOptions.format));
    }

    private updateDateOptions(key: string, newValue: moment.Moment) {
        if (newValue) {
            Vue.set(this.dateOptions, key, newValue);
        } else {
            Vue.set(this.dateOptions, key, false);
        }
    }
}
